import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import 'bootstrap';
import store from "./store";
import "./registerServiceWorker";
import axios from 'axios';
import VueAxios from 'vue-axios';
///import VueFormulate from '@braid/vue-formulate';
import ApiService from "./common/api.service";
import DateFilter from "./common/date.filter";
import ErrorFilter from "./common/error.filter";
import VueFormWizard from "vue-form-wizard";
import VueMask from 'v-mask';
import Vuelidate from 'vuelidate';
import Vuex from "vuex";

Vue.use(VueAxios, axios);
Vue.use(VueFormWizard)

Vue.use(VueMask);
Vue.use(Vuelidate);
Vue.use(Vuex);
Vue.config.productionTip = false;

Vue.filter("date", DateFilter);
Vue.filter("error", ErrorFilter);
ApiService.init();



new Vue({
    router,
    store,
    //dataStore,
    render: h => h(App)
}).$mount("#app");
